import { render } from "./goods_edit.vue?vue&type=template&id=577665c0&scoped=true"
import script from "./goods_edit.vue?vue&type=script&lang=js"
export * from "./goods_edit.vue?vue&type=script&lang=js"

import "./goods_edit.vue?vue&type=style&index=0&id=577665c0&scoped=true&lang=scss"
import "./goods_edit.vue?vue&type=style&index=1&id=577665c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577665c0"]])

export default __exports__